import { pinV1Schema, anyPinSchema, type PinV1 } from './PinV1'

export function migratePin(raw: unknown): PinV1 {
  const tagged = anyPinSchema.parse(raw)
  switch (tagged.schema_version) {
    case 1:
      return pinV1Schema.parse(tagged)
    default:
      throw new Error(`Unknown pin schema_version: ${String(tagged.schema_version)}`)
  }
}
